import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ComingSoon from "./pages/ComingSoon";
import CaseStudiesShowcase from "./pages/case-studies-showcase";
import ServicesArchitectureHub from "./pages/services-architecture-hub";
import ContactSchedulingHub from "./pages/contact-scheduling-hub";
import AdaptiveHomepageHub from "./pages/adaptive-homepage-hub";
import DynamicPortfolioEcosystem from "./pages/dynamic-portfolio-ecosystem";
import AboutPage from "./pages/about";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = sessionStorage.getItem('site_authenticated') === 'true';

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
};

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Coming Soon page as default */}
          <Route path="/" element={<ComingSoon />} />

          {/* Protected routes */}
          <Route
            path="/home"
            element={
              <ProtectedRoute>
                <AdaptiveHomepageHub />
              </ProtectedRoute>
            }
          />
          <Route
            path="/case-studies-showcase"
            element={
              <ProtectedRoute>
                <CaseStudiesShowcase />
              </ProtectedRoute>
            }
          />
          <Route
            path="/services-architecture-hub"
            element={
              <ProtectedRoute>
                <ServicesArchitectureHub />
              </ProtectedRoute>
            }
          />
          <Route
            path="/contact-scheduling-hub"
            element={
              <ProtectedRoute>
                <ContactSchedulingHub />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adaptive-homepage-hub"
            element={
              <ProtectedRoute>
                <AdaptiveHomepageHub />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dynamic-portfolio-ecosystem"
            element={
              <ProtectedRoute>
                <DynamicPortfolioEcosystem />
              </ProtectedRoute>
            }
          />
          <Route
            path="/about"
            element={
              <ProtectedRoute>
                <AboutPage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
